import PropTypes from 'prop-types'

const NOTIFICATION_OPTIONS = {
    CONSOLIDATED: 'CONSOLIDATED',
    CONSOLIDATED_AND_STATEMENT: 'CONSOLIDATED_AND_STATEMENT',
    DETAILED: 'DETAILED',
    DISABLED: 'DISABLED',
    PLAIN: 'PLAIN'
}

/**
 * @typedef {Object} InvoiceNotificationOption
 * @property {string} [stringCode]  - The string code for the translation of the invoice notification option
 * @property {string} [value]       - The invoice notification option itself
 */
export const invoiceNotificationOptionPropType = PropTypes.shape({
    stringCode: PropTypes.string,
    value: PropTypes.oneOf(Object.values(NOTIFICATION_OPTIONS))
})
